import { useEffect } from 'react';

import usePrepareDisclosuresWizard from './usePrepareDisclosuresWizard';

const useRegisterStepSubmit = (step, submit) => {
  const { registerStepSubmit } = usePrepareDisclosuresWizard();

  useEffect(() => {
    registerStepSubmit(step, submit);

    return () => registerStepSubmit(step, null);
  }, [registerStepSubmit, step, submit]);
};

export default useRegisterStepSubmit;
